import script from "./UpdateDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateDevice.vue?vue&type=script&setup=true&lang=js"

import "./UpdateDevice.vue?vue&type=style&index=0&id=5db36a35&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db36a35"]])

export default __exports__